

<!-- header end -->
<!-- body -->
<!-- basecamp -->
<!-- <div class="dlab-bnr-inr overlay-primary" style="background-image:url(.././assets/images/bg_brad.jpg);">
    <div class="overlay_fg">
        <div class="container">
            <div class="dlab-bnr-inr-entry">
                <h1 class="text-white">Terms of service
                </h1>
                <div class="breadcrumb-row">
                    <ul class="list-inline">
                        <li><a routerLink="/">Home</a></li>/
                        <li>terms of service</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div> -->

<div class="privacy_section_part">
    <div class="">
      <div class="row">
        <div class="col-sm-12">
          <h3>Website Terms and Conditions of Use</h3>
          <br>
          <h3>1. Terms</h3>

          <p>By accessing this Website, accessible from https://lookzup.com, you are agreeing to be bound by these Website Terms and Conditions of Use and agree that you are responsible for the agreement with any applicable local laws. If you disagree with any of these terms, you are prohibited from accessing this site. The materials contained in this Website are protected by copyright and trade mark law.</p>
          <br>
          <h3>2. Use License</h3>

          <p>Permission is granted to temporarily download one copy of the materials on LookzUp's Website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:</p>

          <ul style="color: #535353">
              <li style="list-style-type: circle">modify or copy the materials;</li>
              <li style="list-style-type: circle">use the materials for any commercial purpose or for any public display;</li>
              <li style="list-style-type: circle">attempt to reverse engineer any software contained on LookzUp's Website;</li>
              <li style="list-style-type: circle">remove any copyright or other proprietary notations from the materials; or</li>
              <li style="list-style-type: circle">transferring the materials to another person or "mirror" the materials on any other server.</li>
          </ul>
          <p>

          <p>This will let LookzUp to terminate upon violations of any of these restrictions. Upon termination, your viewing right will also be terminated and you should destroy any downloaded materials in your possession whether it is printed or electronic format. These Terms of Service has been created with the help of the <a href="https://www.termsofservicegenerator.net">Terms Of Service Generator</a>.</p>
          <br>
          <h3>3. Disclaimer</h3>

          <p>All the materials on LookzUp’s Website are provided "as is". LookzUp makes no warranties, may it be expressed or implied, therefore negates all other warranties. Furthermore, LookzUp does not make any representations concerning the accuracy or reliability of the use of the materials on its Website or otherwise relating to such materials or any sites linked to this Website.</p>
          <br>
          <h3>4. Limitations</h3>

          <p>LookzUp or its suppliers will not be hold accountable for any damages that will arise with the use or inability to use the materials on LookzUp’s Website, even if LookzUp or an authorize representative of this Website has been notified, orally or written, of the possibility of such damage. Some jurisdiction does not allow limitations on implied warranties or limitations of liability for incidental damages, these limitations may not apply to you.</p>
          <br>
          <h3>5. Revisions and Errata</h3>

          <p>The materials appearing on LookzUp’s Website may include technical, typographical, or photographic errors. LookzUp will not promise that any of the materials in this Website are accurate, complete, or current. LookzUp may change the materials contained on its Website at any time without notice. LookzUp does not make any commitment to update the materials.</p>
          <br>
          <h3>6. Links</h3>

          <p>LookzUp has not reviewed all of the sites linked to its Website and is not responsible for the contents of any such linked site. The presence of any link does not imply endorsement by LookzUp of the site. The use of any linked website is at the user’s own risk.</p>
          <br>
          <h3>7. Site Terms of Use Modifications</h3>

          <p>LookzUp may revise these Terms of Use for its Website at any time without prior notice. By using this Website, you are agreeing to be bound by the current version of these Terms and Conditions of Use.</p>
          <br>
          <h3>8. Your Privacy</h3>

          <p>Please read our Privacy Policy.</p>
          <br>
          <h3>9. Governing Law</h3>

          <p>Any claim related to LookzUp's Website shall be governed by the laws of in without regards to its conflict of law provisions.</p>
  </div>
      </div>
    </div>
</div>


<!-- body -->
<!-- Footer start -->
<!-- footer  -->

<!-- footer end -->

<script src=".././assets/js/jquery-1.12.4.min.js"></script>
<script src=".././assets/js/popper.min.js"></script>
<script src=".././assets/js/bootstrap.min.js"></script>
<script src=".././assets/js/modernizr-3.5.0.min.js"></script>
<script src=".././assets/js/jquery.meanmenu.min.js"></script>
<!-- ma5menu -->
<!-- <script src="assets/js/ma5-menu.min.js"></script> -->
<script src=".././assets/pluging/owl.carousel.min.js"></script>
<script>
    $('.owl-carousel').owlCarousel({
        loop: false,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 3000,
        dots: true,
        autoplayHoverPause: true,
        nav: false,
        responsive: {
            0: {
                items: 2
            },
            600: {
                items: 3
            },
            1000: {
                items: 3
            }
        }
    })
</script>
<script>
    $(function() {
        $(".dropbtn").click(
            function() {
                $('.dropdown-menu', this).stop(true, true).fadeIn("fast");
                $(this).toggleClass('open');
                $('b', this).toggleClass("caret caret-up");
            },
            function() {
                $('.dropdown-menu', this).stop(true, true).fadeOut("fast");
                $(this).toggleClass('open');
                $('b', this).toggleClass("caret caret-up");
            });
    });
</script>
<script>
    // meanmenu
    $('#mobile-menu').meanmenu({
        meanMenuContainer: '.mobile-menu',
        meanScreenWidth: "992"
    });

    $('.info-bar').on('click', function() {
        $('.extra-info').addClass('info-open');
    })

    $('.close-icon').on('click', function() {
        $('.extra-info').removeClass('info-open');
    })
</script>
<!-- Call the script -->
<script>
    $(document).ready(function() {
        ma5menu({
            menu: '.site-menu',
            activeClass: 'active',
            position: 'left',
        });
    });
</script>
